export function replaceUnderscoresWithSpaces(str: string) {
  return str.replace(/_/g, " ");
}
